import Intro from './Question/Intro';
import SingleSelect from './Question/SingleSelect';

export const EPDSQuestionType = {
  SINGLESELECT: 'SINGLESELECT',
  INTRO: 'INTRO',
};

export const epdsQuestionMap = {
  [EPDSQuestionType.INTRO]: Intro,
  [EPDSQuestionType.SINGLESELECT]: SingleSelect,
};
